module.exports = __webpack_public_path__ + "img/no_photo.0acdf7b9.jpg";